import * as geo from 'd3-geo'

/*
 * Returns a new projection with an `alpha` function to control the interpolation
 * between two projections, `a`, and `b`. This works well when the projections
 * are well defined (meaning we can't use it for things like albers usa)
 *
 * This type of projection is needed when modifying paths with different number
 * of coordinates. We need to interpolate the projection rather than interpolate
 * the path.
 */
export default (a, b) => {
  let alpha = undefined
    , projection = geo.geoProjection(raw).scale(1)
    , center = projection.center
    , translate = projection.translate

  function raw (delta, phi) {
    let pa = a([delta *= 180 / Math.PI, phi *= 180 / Math.PI])
      , pb = b([delta, phi])

    return [(1 - alpha) * pa[0] + alpha * pb[0], (alpha - 1) * pa[1] - alpha * pb[1]]
  }

  projection.alpha = function (t) {
    if (!arguments.length) {
      return alpha
    }
    alpha = +t

    let ca = a.center()
      , cb = b.center()
      , ta = a.translate()
      , tb = b.translate()

    center([(1 - alpha) * ca[0] + alpha * cb[0], (1 - alpha) * ca[1] + alpha * cb[1]])
    translate([(1 - alpha) * ta[0] + alpha * tb[0], (1 - alpha) * ta[1] + alpha * tb[1]])

    return projection
  }

  delete projection.scale
  delete projection.translate
  delete projection.center
  return projection.alpha(0)
}
